import { supabase } from '../lib/supabase';

const toCamelCase = (obj) => {
  if (!obj) return obj;
  return {
    id: obj?.id,
    title: obj?.title,
    subtitle: obj?.subtitle,
    description: obj?.description,
    imageUrl: obj?.image_url,
    linkUrl: obj?.link_url,
    linkText: obj?.link_text,
    displayOrder: obj?.display_order,
    isActive: obj?.is_active,
    createdAt: obj?.created_at,
    updatedAt: obj?.updated_at,
  };
};

const toSnakeCase = (obj) => {
  return {
    title: obj?.title,
    subtitle: obj?.subtitle,
    description: obj?.description,
    image_url: obj?.imageUrl,
    link_url: obj?.linkUrl,
    link_text: obj?.linkText,
    display_order: obj?.displayOrder,
    is_active: obj?.isActive,
  };
};

export const carouselService = {
    // Fetch all active carousel items for the public page
    getAllActive: async () => {
        const { data, error } = await supabase
            .from('carousel_items')
            .select('*')
            .eq('is_active', true)
            .order('display_order', { ascending: true });

        if (error) throw error;
        return data?.map(toCamelCase) || [];
    },

    // Fetch all carousel items for the admin dashboard
    getAllAdmin: async () => {
        const { data, error } = await supabase
            .from('carousel_items')
            .select('*')
            .order('display_order', { ascending: true });

        if (error) throw error;
        return data?.map(toCamelCase) || [];
    },

    // Create a new carousel item
    create: async (item) => {
        const { data, error } = await supabase
            .from('carousel_items')
            .insert([toSnakeCase(item)])
            .select()
            .single();

        if (error) throw error;
        return toCamelCase(data);
    },

    // Update a carousel item
    update: async (id, updates) => {
        const { data, error } = await supabase
            .from('carousel_items')
            .update(toSnakeCase(updates))
            .eq('id', id)
            .select()
            .single();

        if (error) throw error;
        return toCamelCase(data);
    },

    // Delete a carousel item
    delete: async (id) => {
        const { error } = await supabase
            .from('carousel_items')
            .delete()
            .eq('id', id);

        if (error) throw error;
        return true;
    },

    // Upload image to storage
    uploadImage: async (file) => {
        const fileExt = file.name.split('.').pop();
        const fileName = `${Math.random()}.${fileExt}`;
        const filePath = `carousel/${fileName}`;

        const { error: uploadError } = await supabase.storage
            .from('images')
            .upload(filePath, file);

        if (uploadError) throw uploadError;

        const { data } = supabase.storage
            .from('images')
            .getPublicUrl(filePath);

        return data.publicUrl;
    }
};
